import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'moon-icon',
  templateUrl: './moon-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MoonIconComponent {}
